import type { ReactNode } from "react";

type PageContainerProps = {
  children: ReactNode;
  className?: string;
};

export default function PageContainer({ children, className }: PageContainerProps) {
  return <div className={`mx-auto max-w-7xl px-6 md:px-8 lg:px-12 ${className || ""}`}>{children}</div>;
}
